import { render, staticRenderFns } from "./FactorialMaterialLayout.vue?vue&type=template&id=a44ae036&scoped=true&"
import script from "./FactorialMaterialLayout.vue?vue&type=script&lang=js&"
export * from "./FactorialMaterialLayout.vue?vue&type=script&lang=js&"
import style0 from "./FactorialMaterialLayout.vue?vue&type=style&index=0&id=a44ae036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44ae036",
  null
  
)

component.options.__file = "FactorialMaterialLayout.vue"
export default component.exports